(function () {
  // Disc gallery: show the selected film in the large projection circle
  document.querySelectorAll('[data-discs]').forEach(function (root) {
    var lens = root.querySelector('[data-disc-lens]');
    var name = root.querySelector('[data-disc-name]');
    var buttons = root.querySelectorAll('[data-disc]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (lens) { lens.src = btn.getAttribute('data-large'); lens.alt = btn.getAttribute('data-name'); }
        if (name) name.textContent = btn.getAttribute('data-name');
      });
    });
  });

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
        main.src = t.getAttribute('data-src');
        main.alt = t.getAttribute('data-alt') || '';
      });
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += parseInt(b.getAttribute('data-step'), 10);
        input.value = Math.max(parseInt(input.min || '1', 10), v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Variant picker: keeps the hidden variant id, price and button in sync
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name=id]');
    var button = form.querySelector('[data-add]');
    var orderBtn = form.querySelector('[data-order]');
    var priceEl = form.closest('[data-product-root]') && form.closest('[data-product-root]').querySelector('[data-price]');
    function money(c) {
      return (c / 100).toLocaleString(undefined, { style: 'currency', currency: form.getAttribute('data-currency') || 'USD' });
    }
    function update() {
      var chosen = Array.prototype.map.call(form.querySelectorAll('.opt'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!match) { if (orderBtn) orderBtn.disabled = true; button.disabled = true; button.textContent = 'Unavailable'; return; }
      idInput.value = match.id;
      button.disabled = !match.available;
      if (orderBtn) orderBtn.disabled = !match.available;
      button.textContent = match.available ? 'Add to cart' : 'Sold out';
      if (priceEl) {
        priceEl.innerHTML = (match.compare_at_price > match.price ? '<s>' + money(match.compare_at_price) + '</s>' : '') + money(match.price);
      }
      history.replaceState(null, '', '?variant=' + match.id);
    }
    form.querySelectorAll('.opt input').forEach(function (i) { i.addEventListener('change', update); });
  });

  // Sticky buy bar: appears early, solid amber strip, hides at the buy section
  var bar = document.querySelector('[data-buybar]');
  if (bar) {
    var target = document.getElementById('buy');
    var onScroll = function () {
      var past = window.scrollY > window.innerHeight * 0.4;
      var atBuy = target && target.getBoundingClientRect().top < window.innerHeight * 0.9 && target.getBoundingClientRect().bottom > 0;
      bar.classList.toggle('is-visible', past && !atBuy);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Attention nudge: every N seconds (theme setting) the Add to cart / Buy now buttons animate
  var body = document.body;
  if (body.getAttribute('data-nudge-on') === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var secs = parseFloat(body.getAttribute('data-nudge-interval')) || 2;
    var visible = function (el) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight && !el.disabled;
    };
    var paused = false;
    document.querySelectorAll('[data-nudge]').forEach(function (el) {
      el.addEventListener('animationend', function () { el.classList.remove('is-nudging'); });
      el.addEventListener('mouseenter', function () { paused = true; });
      el.addEventListener('mouseleave', function () { paused = false; });
    });
    setInterval(function () {
      if (paused || document.hidden) return;
      document.querySelectorAll('[data-nudge]').forEach(function (el) {
        if (visible(el)) { el.classList.remove('is-nudging'); void el.offsetWidth; el.classList.add('is-nudging'); }
      });
    }, secs * 1000);
  }
})();
